import React, { useMemo } from 'react';
import { Segmented } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'router/routes';

import styles from './styles.module.scss';
import { DASHBOARD_TABS, type DashboardTabValue } from './constants';

interface DashboardTabsProps {
  activeTab?: DashboardTabValue;
  onTabChange?: (value: DashboardTabValue) => void;
  hasHomeAccess?: boolean;
  hasRPMAccess?: boolean;
  hasCCMAccess?: boolean;
}

const DashboardTabs: React.FC<DashboardTabsProps> = ({
  activeTab = 'home',
  onTabChange,
  hasHomeAccess = true,
  hasRPMAccess = true,
  hasCCMAccess = true,
}) => {
  const navigate = useNavigate();

  const availableTabs = useMemo(() => {
    return DASHBOARD_TABS.filter((tab) => {
      if (tab.value === 'home' && !hasHomeAccess) return false;
      if (tab.value === 'rpm' && !hasRPMAccess) return false;
      if (tab.value === 'ccm' && !hasCCMAccess) return false;
      return true;
    });
  }, [hasHomeAccess, hasRPMAccess, hasCCMAccess]);

  const handleTabChange = (value: DashboardTabValue) => {
    if (value === 'home') {
      navigate(Routes.homeDashboard);
    } else if (value === 'rpm') {
      navigate(Routes.dashboard);
    } else if (value === 'ccm') {
      navigate(Routes.ccm);
    }
    onTabChange?.(value);
  };

  return (
    <Segmented
      options={availableTabs}
      value={activeTab}
      onChange={(val) => handleTabChange(val as DashboardTabValue)}
      className={styles.segmented}
    />
  );
};

export default DashboardTabs;
